import React from "react";
import { Button } from "reactstrap";

const ButtonAddRole = ({ open, roleToAdd }) => {
  return (
    <Button
      onClick={open}
      color="soft-primary"
      size="md"
      className="py-0 d-flex align-items-center border border-primary"
    >
      <i className="mdi mdi-plus fs-3 p-0 me-3"></i> Add {roleToAdd}
    </Button>
  );
};

export default ButtonAddRole;
